interface BrowserVersions {
  chrome: number;
  safari: number;
  firefox: number;
}

const MINIMUM_VERSIONS: BrowserVersions = {
  chrome: 111,
  safari: 16.4,
  firefox: 128,
};

export const useBrowserCompatibility = () => {
  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;

    // Chrome version
    const chromeMatch = userAgent.match(/Chrome\/(\d+)/);
    const chromeVersion = chromeMatch ? parseInt(chromeMatch[1], 10) : Infinity;

    // Safari version
    const safariMatch = userAgent.match(/Version\/(\d+)\.(\d+)/);
    const safariVersion = safariMatch
      ? parseFloat(`${safariMatch[1]}.${safariMatch[2]}`)
      : Infinity;

    // Firefox version
    const firefoxMatch = userAgent.match(/Firefox\/(\d+)/);
    const firefoxVersion = firefoxMatch
      ? parseInt(firefoxMatch[1], 10)
      : Infinity;

    return {
      isChrome: /Chrome/.test(userAgent) && !/Edg/.test(userAgent),
      isSafari: /Safari/.test(userAgent) && !/Chrome/.test(userAgent),
      isFirefox: /Firefox/.test(userAgent),
      chromeVersion,
      safariVersion,
      firefoxVersion,
    };
  };

  const browserInfo = getBrowserInfo();

  const isUnsupportedBrowser =
    (browserInfo.isChrome &&
      browserInfo.chromeVersion < MINIMUM_VERSIONS.chrome) ||
    (browserInfo.isSafari &&
      browserInfo.safariVersion < MINIMUM_VERSIONS.safari) ||
    (browserInfo.isFirefox &&
      browserInfo.firefoxVersion < MINIMUM_VERSIONS.firefox);

  // Return detailed information for debugging and analytics
  return {
    isUnsupportedBrowser,
    browserInfo: {
      ...browserInfo,
      minimumVersions: MINIMUM_VERSIONS,
    },
  };
};
